import { render, staticRenderFns } from "./OC.vue?vue&type=template&id=223a37a8&"
import script from "./OC.vue?vue&type=script&lang=js&"
export * from "./OC.vue?vue&type=script&lang=js&"
import style0 from "./OC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports